/**
 * Returns the portal JWT from localStorage, or null if not present.
 * @returns {string|null}
 */
export const getPortalJwt = () => localStorage.getItem('token');
